import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationBetsukaiPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationBetsukai,
);
